module.exports = __webpack_public_path__ + "50c0b70115452c7aa89104c28781beb0.jpg";